import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Info } from "@air/next-icons";
import { Slider } from "@air/primitive-slider";
import { Tooltip } from "@air/primitive-tooltip";
import { memo, useCallback, useMemo } from "react";
const MAX_VALUE = 90;
const MIN_VALUE = 30;
export const ColorThresholdControl = /*#__PURE__*/ memo((param)=>{
    let { defaultValue: _defaultValue, onThresholdChange } = param;
    const defaultValue = useMemo(()=>{
        var _defaultValue_;
        const value = ((_defaultValue_ = _defaultValue === null || _defaultValue === void 0 ? void 0 : _defaultValue[0]) !== null && _defaultValue_ !== void 0 ? _defaultValue_ : 0) * 100;
        const invertedValue = MAX_VALUE + MIN_VALUE - value;
        return [
            invertedValue
        ];
    }, [
        _defaultValue
    ]);
    const onValueCommit = useCallback((value)=>{
        const invertedValue = MAX_VALUE + MIN_VALUE - value[0];
        const threshold = invertedValue / 100;
        onThresholdChange(threshold);
    }, [
        onThresholdChange
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex w-full flex-col items-start gap-3",
        "data-testid": "COLOR_RANGE_CONTROL",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex items-center gap-1",
                children: [
                    /*#__PURE__*/ _jsx("p", {
                        className: "text-12 font-medium text-grey-12",
                        children: "Color range"
                    }),
                    /*#__PURE__*/ _jsx(Tooltip, {
                        label: "Adjust how closely colors need to match. Lower settings show exact matches. Higher settings include a wider range of similar hues, tones, and shades.",
                        className: "w-[240px]",
                        children: /*#__PURE__*/ _jsx(Info, {
                            className: "size-4 text-grey-8"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex w-full flex-col items-start gap-3 rounded-8 border border-grey-5 px-4 py-3 pb-4",
                children: [
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex w-full items-center justify-between",
                        children: [
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-10 text-grey-12",
                                children: "Narrow"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "text-10 text-grey-12",
                                children: "Wide"
                            })
                        ]
                    }),
                    /*#__PURE__*/ _jsx(Slider, {
                        rangeColor: "grey",
                        defaultValue: defaultValue,
                        onValueCommit: onValueCommit,
                        step: 1,
                        max: MAX_VALUE,
                        min: MIN_VALUE,
                        "data-testid": "COLOR_RANGE_SLIDER"
                    })
                ]
            })
        ]
    });
});
ColorThresholdControl.displayName = "ColorThresholdControl";
